import DigitalProductTypes from './digitalProductTypes';
import { oryBasePath } from './oryContstants';

export const pathPrefixes = {
  myAccount: 'my-account',
};

export const paths = {
  home: '/',
  myAccount: `/${pathPrefixes.myAccount}/dashboard`,
  purchaseGuaranteeByLink: `/products/${DigitalProductTypes.GuaranteePlus}?serviceId=true`,
  orders: `/${pathPrefixes.myAccount}/orders`,
  legacyOrders: `/${pathPrefixes.myAccount}/legacy/orders`,
  returnRequest: `/${pathPrefixes.myAccount}/return-request`,
  devices: `/${pathPrefixes.myAccount}/devices`,
  services: `/${pathPrefixes.myAccount}/services`,
  legacySmartHosting: `/${pathPrefixes.myAccount}/legacy/smart-hosting`,
  club: `/${pathPrefixes.myAccount}/club`,
  clubSurvey: `/${pathPrefixes.myAccount}/club/survey`,
  nukiClubLanding: '/nuki-club',
  profile: `/${pathPrefixes.myAccount}/profile`,
  crystallizeRoot: '/webhierarchydraft',
  crystallizeRootHermes: '/webhierarchyhermes',
  crystallizeGlobal: '/global',
  crystallizeGlobalHermes: '/global-hermes',
  directPurchaseProductLinks: {
    'guarantee-plus': `/webhierarchydraft/products/${DigitalProductTypes.GuaranteePlus}`,
    'remote-access-smart-lock': `/webhierarchydraft/products/${DigitalProductTypes.RemoteAccess}`,
    'remote-access-smart-lock-go': `/webhierarchydraft/products/${DigitalProductTypes.RemoteAccess}`,
    'remote-access-smart-door':
      '/webhierarchydraft/products/smart-door-remote-access-activation-code',
    'smart-hosting': `/webhierarchydraft/products/${DigitalProductTypes.SmartHosting}`,
    smartHostingUs: '/webhierarchyhermes/products/smart-hosting',
    guaranteePlusUs: '/webhierarchyhermes/products/guarantee-plus',
    smartlockPro5: '/webhierarchydraft/products/smart-lock-pro-5th-gen',
    smartlockUltra: '/webhierarchydraft/products/smart-lock-ultra',
    opener: '/webhierarchydraft/products/opener',
    kp2nfc: '/webhierarchydraft/products/smart-lock-pro-5th-gen',
    cableExchange: '/webhierarchydraft/products/spare-parts/cables',
    cableExchangeUs: '/webhierarchyhermes/products/spare-parts/cables',
  },
  login: `${oryBasePath}/ui/login`,
  changePassword: `${oryBasePath}/ui/settings`,
  nukiWebLogin: 'https://web.nuki.io/#/login',
  checkout: '/checkout',
  paymentFailed: '/payment-failed',
  orderReceived: '/order-received',
  b2bContactForm: '/b2b-contact-form',
  usLandingPage: '/usa',
  usEarlyBirdPrefix: '/usa-early-bird',
  directPurchaseLink: '/direct-purchase',
  productById: '/product-by-id',
  installationCheck: '/find-your-solution',
  installationCheckUs: '/find-your-solution-us',
  installationCheckResultsRestrictedNordics:
    '/global/installation-check/results/installation-check-result-restricted-nordics',
  installationCheckResultsRestrictedGoPro:
    '/global/installation-check/results/installation-check-result-restricted-go-pro',
  installationCheckResultsRestrictedGo:
    '/global/installation-check/results/installation-check-result-restricted-go',
  installationCheckResultsRestrictedUltraGo:
    '/global/installation-check/results/installation-check-result-restricted-ultra-go',
  installationCheckResultsRestrictedUltra:
    '/global/installation-check/results/installation-check-result-restricted-ultra',
  installationCheckResultsGoodCompatibility:
    '/global/installation-check/results/installation-check-result-good-compatibility',
  installationCheckResultsRestrictedGoUK:
    '/global/installation-check/results/installation-check-result-restricted-go-uk',
  installationCheckResultsRestrictedUs:
    '/global/installation-check/results/installation-check-result-restricted-us',
  installationCheckResultsRestrictedUsEuro:
    '/global/installation-check/results/installation-check-result-restricted-us-euro',
  page404: '/global/404',
  productOverview: '/products/product-overview?filter=services',
  productOverviewMainPage: '/products/product-overview',
  withdrawal: '/withdraw',
};

export const pathsHideBanner = [
  '/contact-support', // en
  '/support-kontaktieren', // de
  '/contacter-le-support', // fr
  '/contactar-con-soporte', // es
  '/contatta-il-supporto', // it
  'neem-contact-op-met-support', // nl
  '/support-and-contact/shipping-and-returns/overview', // en
  '/support-und-kontakt/versand-und-ruecksendung/uebersicht', // de
  '/support-et-contact/expedition-et-retours/apercu', // fr
  '/asistencia-y-contacto/spedizione-e-resi/resumen', // es
  '/supporto-e-contatto/verzending-en-terugsturen/panoramica', // it
  '/support-en-contact/footer-shipping-and-returns/overzicht', // nl
];

export const hideHeaderFooterPaths = [
  '/usa-early-bird/smart-lock-get-started',
  '/usa-early-bird/smart-lock-upgrade',
  '/usa-early-bird/smart-lock-vacation-rental',
  '/partners/smart-access-overview',
  '/partner/smarter-zutritt-ubersicht',
  '/partenaires/apercu-acces-intelligent',
  '/socios/acceso-inteligente-resumen',
  '/partner/panoramica-accesso-intelligente',
  '/partners/slimme-toegang-overzicht',
];
